import React,{useState} from 'react'
import "../App.css";
import { useNavigate } from "react-router-dom";

const Input = () => {
  const [inputValue, setInputValue] = useState('');
  const [KeyValue, setKeyValue] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleChange1 = (e) => {
    setKeyValue(e.target.value);
  };

  const firstpage = () => {
    navigate("/");
  };

  const secondpage = () => {
    if(inputValue.length === 0 || KeyValue.length === 0){
      alert("Please enter a valid key");
      return;
    }
    else{
    navigate('/initial', { state: { inputValue, KeyValue, hexplaintext, hexkey } });
    }
  };

  const stringToHexadecimal = (input) => {
    let result = '';
    for (let i = 0; i < 8; i++) {
      const char = input[i] ? input.charCodeAt(i).toString(16).toUpperCase() : '00';
      result += char.padStart(2, '0');
      if (i < 7) {
        result += ' '; // Add a space between every two characters
      }
    }
    return result;
  };
  

  const hexplaintext = stringToHexadecimal(inputValue);
  const hexkey = stringToHexadecimal(KeyValue);



  return (

    <>
    
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>In this page the user has to enter the plaintext that has to be encrypted and the encryption key.
      </p>
    </div>
    <div className="input-container">
      <div className="flex flex-col items-center">
        
        <div className="pt-10">
          <h1>Enter the Plaintext to be Encrypted</h1>
          <br />

        </div>
        <div class="input-box">
        <input 
          maxLength="8" 
          className='border-solid border-3 bg-slate-100 px-2 py-2 rounded-md' 
          type="text"
          placeholder='Enter any alphanumeric value' 
          value={inputValue}
          onChange={handleChange}/>
          <br /><br />

        </div> 

        <div className="pt-10">
          <h1>Enter the Encryption Key</h1>
          <br />

        </div>
        <div class="input-box">
        <input 
          maxLength="8" 
          className='border-solid border-3 bg-slate-100 px-2 py-2 rounded-md' 
          type="text"
          placeholder='Enter any alphanumeric value' 
          value={KeyValue}
          onChange={handleChange1}/>
          <br /><br />

        </div> 

        <div class="button-holder">
        <div class="prev-button" onClick={firstpage}>
            PREVIOUS
          </div>
          <div className="next-button" onClick={secondpage}>
            NEXT
          </div>
        </div>
      </div>
    </div></>
  );
};

export default Input